import { useGSAP } from "@gsap/react";
import gsap from 'gsap';
import Animal from "./Animal";
import { useEffect, useRef, useState } from "react";

function OtherPlayer({ player, activePlayerId, onClick=null, onAnimationComplete }) {
    const otherPlayerRef = useRef();
    const [animation, setAnimation] = useState(player.animation);
    const [displayedHandCount, setDisplayedHandCount] = useState(player.animation ? player.previousHand.length : player.hand.length);

    let bgClass = '';

    if (player.id === activePlayerId) {
        bgClass += 'bg-cyan-900/25 ';
        if (onClick) bgClass += 'hover:bg-cyan-800/25 cursor-pointer ';
    } else {
        bgClass += 'bg-neutral-900 ';
        if (onClick) bgClass += 'hover:bg-neutral-800 cursor-pointer ';
    }

    useEffect(() => {
        // console.log('PLAYER UPDATED: ', player)
        setAnimation(player.animation)
        if (player.animation) {
            setDisplayedHandCount(player.previousHand.length)
        } else {
            setDisplayedHandCount(player.hand.length)
        }
    }, [player]);

    useGSAP(() => {
        switch (animation) {
            case 'fadeDown':
                // console.log('fadown')
                gsap.fromTo(otherPlayerRef.current.querySelector('.hand').children, {
                    y: 0,
                    opacity: 1,
                }, {
                    y: 5,
                    opacity: 0,
                    ease: 'power1.in',
                    stagger: {
                        amount: 0.1
                    },
                    onComplete: () => {
                        setDisplayedHandCount(player.hand.length);
                        setAnimation('fadeUp');
                    }
                });
                break;
            case 'fadeUp':
                // console.log('fadup')
                gsap.fromTo(otherPlayerRef.current.querySelector('.hand').children, {
                    y: 5,
                    opacity: 0,
                }, {
                    y: 0,
                    opacity: 1,
                    ease: 'power1.out',
                    stagger: {
                        amount: 0.1
                    },
                    onComplete: () => {
                        setAnimation(null);
                        onAnimationComplete(player.id);
                    }
                });
                break;
            case 'cycle-right-out':
                gsap.fromTo(otherPlayerRef.current.querySelector('.hand'), {
                    x: 8,
                    opacity: 1,
                }, {
                    x: 18,
                    opacity: 0,
                    ease: 'power1.in',
                    duration: 0.333,
                    onComplete: () => {
                        setDisplayedHandCount(player.hand.length);
                        setAnimation('cycle-right-in');
                    }
                });
                break;
            case 'cycle-right-in':
                gsap.fromTo(otherPlayerRef.current.querySelector('.hand'), {
                    x: -2,
                    opacity: 0,
                }, {
                    x: 8,
                    opacity: 1,
                    ease: 'power1.out',
                    duration: 0.333,
                    onComplete: () => {
                        setAnimation(null);
                        onAnimationComplete(player.id);
                    }
                });
                break;
            case 'cycle-left-out':
                gsap.fromTo(otherPlayerRef.current.querySelector('.hand'), {
                    x: 8,
                    opacity: 1,
                }, {
                    x: -2,
                    opacity: 0,
                    ease: 'power1.in',
                    duration: 0.333,
                    onComplete: () => {
                        setDisplayedHandCount(player.hand.length);
                        setAnimation('cycle-left-in');
                    }
                });
                break;
            case 'cycle-left-in':
                gsap.fromTo(otherPlayerRef.current.querySelector('.hand'), {
                    x: 18,
                    opacity: 0,
                }, {
                    x: 8,
                    opacity: 1,
                    ease: 'power1.out',
                    duration: 0.333,
                    onComplete: () => {
                        setAnimation(null);
                        onAnimationComplete(player.id);
                    }
                });
                break;
            default:
                break;
        }
    }, [animation]);

    return (
        <aside onClick={onClick} className={"w-[206px] shrink-0 border border-neutral-500 rounded-md p-2 " + bgClass} ref={otherPlayerRef}>
            <p className="text-center border-b pb-1 border-neutral-400 mb-2 text-neutral-100 font-semibold">
                {player.name}
            </p>
            <div className="flex">
                <Animal animal={player.animal} />
                <OtherHand cardCount={displayedHandCount} />
            </div>
        </aside>
    );
}

function OtherHand({ cardCount }) {
    const gridTemplateColumns = `repeat(${Math.min(cardCount, 10)},10px)`;

    return (
        <div className={`translate-x-2 grid place-content-center hand`} style={{ gridTemplateColumns: gridTemplateColumns }}>
            {Array.from({ length: Math.min(cardCount, 10) }, (_, index) => (
                index === Math.min(cardCount, 10) - 1 ? (
                    <div key={index} className={`h-12 w-9 bg-cyan-950 border border-neutral-200 rounded grid place-items-center text-neutral-300 z-[${index}] relative`}>
                        {cardCount}
                    </div>
                ) : (
                    <div key={index} className={`h-12 w-9 bg-cyan-950 border border-neutral-200 rounded z-[${index}] relative`}></div>
                )
            ))}
        </div>
    )
}

export default OtherPlayer;